module.exports = __webpack_public_path__ + "assets/images/748a46d9943e7fad9bb98c4b0383d453.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/logos/amex-logo.svg
// module id = 819
// module chunks = 0